<template>
  <div class="Loadingscreen">
    <div id="ls-container" >
      <img class="ls-background" :src="backgroundImage" alt="" />

      <div class="ls-overlay">
        <!-- Default Loadingscreen -> GIF -->
        <div v-show="spoilerID != 0" class="spoiler-card">
          <div class="body">
            <h2 v-if="this.chosenLanguage=='de'">{{ spoilers[spoilerID].title }}</h2>
            <p v-if="this.chosenLanguage=='de'">{{ spoilers[spoilerID].explanation }}</p>
            <h2 v-if="this.chosenLanguage=='en'">{{ spoilers_en[spoilerID].title }}</h2>
            <p v-if="this.chosenLanguage=='en'">{{ spoilers_en[spoilerID].explanation }}</p>
          </div>
          <div class="footer">
            <svg
              v-show="loadingValue < 100"
              class="ls-animation"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 80 80"
              xml:space="preserve"
            >
              <path
                id="spinner"
                d="M40,72C22.4,72,8,57.6,8,40C8,22.4,22.4,8,40,8c17.6,0,32,14.4,32,32c0,1.1-0.9,2-2,2s-2-0.9-2-2c0-15.4-12.6-28-28-28S12,24.6,12,40s12.6,28,28,28c1.1,0,2,0.9,2,2S41.1,72,40,72z"
              >
                <animateTransform
                  attributeType="xml"
                  attributeName="transform"
                  type="rotate"
                  from="0 40 40"
                  to="360 40 40"
                  dur="1s"
                  repeatCount="indefinite"
                />
              </path>
            </svg>
            <!-- <svg id="loadingArrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 32">
                            <path id="la-1" d="M23,9v14h-22V9h22m1-1h-24V24h24V8h0Z"/>
                            <path id="la-2" d="M55,9v14h-22V9h22m1-1h-24V24h24V8h0Z"/>
                            <path id="la-3" d="M87,9v14h-22V9h22m1-1h-24V24h24V8h0Z"/>
                            <path id="la-4" d="M113,2.41l13.59,13.59-13.59,13.59v-6.59h-16V9h16V2.41m-1-2.41V8h-16V24h16v8l16-16L112,0h0Z"/>
                        </svg> -->
            <p
              class="ls-text"
              v-show="enablePreloadAllSituations && loadingValue < 100"
            >
             <!-- {{ loadingValue }}% -->
            </p>
            <button
              v-show="loadingValue == 100"
              class="primary icon-right"
              @click="clicked()"
            >
              <div class="icon">
                <ChevronRight />
              </div>
              <div class="text" v-if="this.chosenLanguage=='de'">Weiter</div>
              <div class="text" v-if="this.chosenLanguage=='en'">Continue</div>
            </button>
          </div>
        </div>

        <div class="spoiler-preview">
          <img class="ls-logo" :src="publicPath + '/media/' + logoURL" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";

export default {
  data: () => ({
    publicPath: process.env.BASE_URL,
    loadingValue: 0,
    spoilerID: 0,
    showSpoiler: true,
    spoilers: [
      {
        key: "Empty",
        title: "Empty",
        explanation:
          "",
      },
      {
        key: "Empfang",
        title: "Empfang",
        explanation:
          "Wir heißen Sie herzlich Willkommen bei der 360° Tour durch unsere Ausbildungsplätze. Erleben Sie, wie unsere Auszubildenden Ihnen unsere wichtigsten Prozesse näherbringen.",
      },
      {
        key: "Uebersicht",
        title: "Übersicht",
        explanation:
          "Im Übersichtsraum können Sie zu den einzelnen Stationen springen. Dort werden Ihnen die einzelnen Produktionsschritte von unseren Auszubildenden näher erklärt.",
      },
      {
        key: "Lukas",
        title: "Mischen mit Lukas",
        explanation:
          "Im ersten Schritt muss das Kunststoffgemisch abgewogen und gemischt werden. Dazu werden die Farbpigmente grammgenau dem Kunststoffgranulat beigefügt.",
      },
      {
        key: "Moritz",
        title: "Extruder mit Moritz",
        explanation:
          "Das Granulat wird hier über die Schnecke aufgeschmolzen und homogenisiert. Die Schmelze wird strangförmig der Kühlstrecke zugeführt.",
      },
      {
        key: "Pascal",
        title: "Kühlung und Granulator mit Pascal",
        explanation:
          "Der heiße Kunststoffstrang aus dem Extruder wird an dieser Station in einem Wasserbecken abgekühlt und anschließend mittels Granulator zur Weiterverarbeitung granuliert.",
      },
      {
        key: "Ibrahim",
        title: "Trocknen mit Ibrahim",
        explanation:
          "In diesem Produktionsschritt wird das Granulat gleichmäßig auf ein Trockenblech verteilt und in einem auf 90°C vorgeheizten Trockenschrank getrocknet.",
      },
      {
        key: "Christoph",
        title: "Spritzguss mit Christoph",
        explanation:
          "Das getrocknete Granulat wird hier in den Trichter der Spritzgießmaschine gegeben. Es wird aufgeschmolzen und mittels Förderschnecke in das Spritzgießwerkzeug gespritzt.",
      },
      {
        key: "Torben",
        title: "Qualitätssicherung mit Torben",
        explanation:
          "Im letzten Schritt erfolgt eine Qualitätskontrolle der hergestellten Produkte. Dabei können fehlerhafte Teile aussortiert werden.",
      },
    ],
    spoilers_en: [
      {
        key: "Empty",
        title: "Empty",
        explanation:
          "",
      },
      {
        key: "Empfang",
        title: "Reception",
        explanation:
          "We warmly welcome you to the 360° tour of our apprenticeship positions. Experience how our apprentices bring you closer to our most important processes.",
      },
      {
        key: "Uebersicht",
        title: "Overview",
        explanation:
          "In the overview room, you can jump to the individual stations. There the individual production steps will be explained to you in more detail by our apprentices.",
      },
      {
        key: "Lukas",
        title: "Mix with Lukas",
        explanation:
          "In the first step, the plastic mixture must be weighed and mixed. For this purpose, the colour pigments are added to the plastic granules to the exact gram.",
      },
      {
        key: "Moritz",
        title: "Extruder with Moritz",
        explanation:
          "The granulate is melted and homogenized here via the screw. The melt is fed to the cooling line in strand form.",
      },
      {
        key: "Pascal",
        title: "Cooling and Granulator with Pascal",
        explanation:
          "The hot strand of plastic from the extruder is cooled in a water tank at this station and then granulated by a granulator for further processing.",
      },
      {
        key: "Ibrahim",
        title: "Drying with Ibrahim",
        explanation:
          "In this production step, the granulate is distributed evenly on a drying tray and dried in a drying cabinet preheated to 90°C.",
      },
      {
        key: "Christoph",
        title: "Injection moulding with Christoph",
        explanation:
          "The dried granulate is fed into the funnel of the injection moulding machine. It is melted and injected into the injection mould using a worm screw.",
      },
      {
        key: "Torben",
        title: "Quality control with Torben",
        explanation:
          "The final step is quality control of the manufactured products. Defective parts can be sorted out.",
      },
    ],
  }),
  computed: {
    ...mapGetters([
      "logoURL",
      "currentSituation",
      "thumbnailType",
      "panoramaTour",
      "enablePreloadAllSituations",
      "chosenLanguage",
    ]),
    backgroundImage() {
      if (this.panoramaTour)
        return (
          this.publicPath +
          "/media/Evonik360/Stations/" +
          this.currentSituation?.name.trim() +
          "/" + 
          this.currentSituation?.name.trim() +
          "_LoadingScreen." +
          this.thumbnailType
        );
      else return null;
    },
  },
  watch: {
    loadingValue() {
      // if(this.loadingValue>=0){
      //         if(this.loadingValue<=25){
      //             var part = document.getElementById("la-1");
      //         }
      //         if(this.loadingValue>25 && this.loadingValue<=50) {
      //             var part = document.getElementById("la-2")
      //         }
      //         if(this.loadingValue>50 && this.loadingValue<=75){
      //             var part = document.getElementById("la-3")
      //         }
      //         if(this.loadingValue>75 && this.loadingValue<=100){
      //             var part = document.getElementById("la-4")
      //         }
      //     var styles = window.getComputedStyle(part,":before");
      //     styles.setProperty("width",(this.loadingValue%25)+"%");
      // }
    },
    currentSituation() {
      var searchItem = this.currentSituation?.name.trim().split("_")[2];
    
      this.spoilerID = this.spoilers.findIndex(
        (elem) => elem.key == searchItem
      );
     
      if((this.currentSituation?.name.includes("Loop"))||
         (this.currentSituation?.name.includes("2_3_Moritz"))||
        (this.currentSituation?.name.includes("6_3_Torben"))||
        (this.currentSituation?.name.includes("6_4_Torben"))||
        (this.currentSituation?.name.includes("6_5_Torben"))||
        (this.currentSituation?.name.includes("6_6_Torben"))
        ){
      
        this.spoilerID = 0;
        this.showSpoiler= false;
        
        this.setLoadingScreenWanted(false);
      }
      else {
         this.showSpoiler= true;
         this.setLoadingScreenWanted(true);
      }
         
    },
  },
  methods: {
    ...mapMutations(["setLoadingscreenVisible", "setLoadingScreenWanted"]),
    clicked(){
     
      this.setLoadingscreenVisible(0)
      window.dispatchEvent(new CustomEvent("startVideo"));       
    }
  },
  mounted: function () {
    document.getElementById("ls-container").style.opacity = 1;
    window.addEventListener("updateLoadingValue", (e) => {
      //Convert String to Number for more calculation possibilities
      this.loadingValue = parseInt(e.detail.value.split("%")[0]);
    });
  },
  components: { ChevronRight },
};
</script>

<style>
.Loadingscreen {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 100;
  display: block;
  justify-content: center;
  align-items: center;
  background: rgb(200, 200, 200);
}
#ls-container {
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: 1s opacity ease-in;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ls-background {
  position: absolute;
  height: 100vh !important;
  width: 100vw !important;
  object-fit: cover;
  filter: blur(4px);
  opacity: 0.3;
}

.ls-overlay {
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-end;
  top: 0;
  width: 80%;
  height: 80%;
  z-index: 1;
}

.ls-overlay .spoiler-card {
  width: 40%;
  min-width: 220px;
  padding: 3rem;
  padding-bottom: 6rem;

  background: linear-gradient(
    to top,
    transparent,
    rgba(255, 255, 255, 0.85) 4rem
  );
  border-radius: 10px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;

  display: flex;
  flex-direction: column;
  gap: 24px;
}
.ls-overlay .spoiler-card .body {
  flex-grow: 1;
  overflow: auto;
}
.ls-overlay .spoiler-card .footer {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
}
.ls-overlay .spoiler-preview {
  height: 100%;
  flex-grow: 1;

  display: flex;
  justify-content: top;
  align-items: flex-start;
}
.ls-video {
  width: 100px;
}
.ls-logo {
  width: 200px;
  height: 200px;
}
.ls-animation {
  fill: var(--primaryColor);
  width: 40px;
  height: 40px;
  display: block;
}
#loadingArrow path {
  position: relative;
}
#loadingArrow path:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  background-color: var(--primaryColor);
}
.ls-text {
  font-size: 25px;
  text-align: center;
  margin: 20px;
  color: white;
  filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.4))
    drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.2));
}
</style>
